<script lang="ts">
	import type { PageProps } from "./$types";
	import { PodcastSection } from "#lib/web-ui/blocks/index.js";
	import { PodcastInquirySection } from "#lib/web-ui/blocks/podcast-inquiry/index.js";

	let { data }: PageProps = $props();
</script>

<svelte:head>
	<title>Real Estate Investing Podcast Appearances | Fergmar Capital</title>
	<meta
		name="description"
		content="Brian Ferguson shares strategies for passive real estate investing, syndication deal structures, and wealth building through commercial real estate."
	/>
	<meta
		property="og:title"
		content="Real Estate Investing Podcast Appearances | Fergmar Capital"
	/>
	<meta
		property="og:description"
		content="Brian Ferguson shares passive investing strategies, syndication deal structures, and wealth building through commercial real estate."
	/>
	<meta
		name="twitter:title"
		content="Real Estate Investing Podcast Appearances | Fergmar Capital"
	/>
	<meta
		name="twitter:description"
		content="Brian Ferguson shares passive investing strategies and syndication deal structures on leading real estate podcasts."
	/>

	{@html `<script type="application/ld+json">${JSON.stringify({
		"@context": "https://schema.org",
		"@type": "ItemList",
		name: "Fergmar Capital Podcast Appearances",
		url: "https://fergmarcapital.com/media/podcasts",
		numberOfItems: data.podcastEpisodes.length,
		itemListElement: data.podcastEpisodes.slice(0, 10).map((ep, i) => ({
			"@type": "ListItem",
			position: i + 1,
			item: {
				"@type": "PodcastEpisode",
				name: ep.title,
				datePublished: ep.publishedAt,
				image: ep.imageUrl,
				partOfSeries: { "@type": "PodcastSeries", name: ep.channelTitle },
				associatedMedia: { "@type": "AudioObject", contentUrl: ep.audioUrl }
			}
		}))
	})}</script>`}
</svelte:head>

<h1 class="sr-only">Real Estate Investing Podcast Appearances with Brian Ferguson</h1>

<PodcastSection
	label="Podcast Features"
	title="Hear From Brian Ferguson"
	subtitle="Brian Ferguson joins leading real estate podcasts to share hands-on strategies for building wealth through commercial real estate."
	episodes={data.podcastEpisodes}
	theme="light"
/>

<PodcastInquirySection theme="muted" />
